import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './FiveDayUpandDown.css';
import Pagination from '../../CommonUI/Pagination/Pagination';
import { useLocalStorage } from "../../utils/useLocalStorage";
import MarketEquity from "../MarketEquity";
import { Vortex } from 'react-loader-spinner'
import CallTrackApi from "../../Activity_Track/CallTrackApi";

function DayUpandDown(props) {
    const [data, setData] = useState([]);
    let optionInfoMarket = "5 Days Up / Down";
    let optionTypeComp = "Daily Market Tracker";
    const [valuebtn, setValueBtn] = useState("desc");
    const [cocode, setcocode] = useLocalStorage("cocode", "");
    // const [valueLi, setValueLi] = useState("Day");
    const [dataGroup, setDataGroup] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [groupValue, setGroupValue] = useState("BSE");
    const [groupIndex, setGroupIndex] = useState("BSE_SENSEX");
    const [groupIndexNSE, setGroupIndexNSE] = useState("NIFTY");
    const { BaseURL } = useContext(URLstateContext);
    const [loadingshow, setloadingshow] = useState(false);
    let getData, getDataGroup, eleBtn, eleBtnLoose, eleLi;
    let PageSize = 8;

    // useEffect(() => {
    //     setTimeout(() => {
    //         eleBtn.classList.add('active');
    //         eleLi.classList.add('active');
    //     })
    // }, [])
    useEffect(() => {
        setloadingshow(true);
        if (groupValue === "BSE") {
            const getUrl = BaseURL + "DayUpandDown";
            fetch(`${getUrl}/${groupValue}/${groupIndex}/-/${valuebtn}`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);
                    //console.log(getData, "getData")
                })
                .catch((error) => {
                });
        } else {
            const getUrl = BaseURL + "DayUpandDown";
            fetch(`${getUrl}/${groupValue}/${groupIndexNSE}/-/${valuebtn}`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);
                    //console.log(getData, "getData")
                })
                .catch((error) => {
                });
        }

        const getUrlGroup = BaseURL + "GroupMaster";
        fetch(`${getUrlGroup}/${groupValue}`)
            .then((response) => response.json())
            .then((dataG) => {
                getDataGroup = dataG.data;
                setDataGroup(getDataGroup);
                //console.log(getDataGroup, "getDataGroup")
            })
            .catch((error) => {
            });

    }, [groupValue, valuebtn, groupIndex, groupIndexNSE]);



    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);
    const routeChange = (event) => {
        const compcocode = event.currentTarget.dataset.id;
        const compcode_array = compcocode.split('-');
        const getCoCodeId = compcode_array[0].replace(/ /g, '-').replace('&', 'and').replace('+', '');
        setcocode(compcode_array[1]);
        window.open("/stocks/" + getCoCodeId.toLowerCase(), '_blank');
    };
    CallTrackApi("5 Days Up Down",window.location.href);

    return (
        <>
            <div class="col-12 p-0 breadcrum ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/stocks">Stocks</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>5 Days Up / Down</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='gainer-loser-sc'>
                            <div className='gainer-header'>
                                <h2><span> 5 Days Up / Down</span></h2>
                            </div>
                            <MarketEquity optionInfoMarket={optionInfoMarket} optionTypeComp={optionTypeComp} />
                            <div className='value-table-main'>
                                <div className="valuetopperselect">
                                    <div className='value-loser-toggle'>
                                        <button id="desc" value="desc" className={(valuebtn === "desc") ? "active" : ''} onClick={(event) => { setValueBtn(event.target.value) }}>Up</button>
                                        <button id="asc" value="asc" className={(valuebtn === "asc") ? "active" : ''} onClick={(event) => { setValueBtn(event.target.value) }}>Down</button>
                                    </div>

                                    {/* <div className='DayUp-right'> */}
                                        <div className='value-inner-select_I'>
                                            
                                            {/* aria-label="bse nse" */}
                                            <select aria-label="bse nse" onChange={(event) => { setGroupValue(event.target.value); setGroupIndex("BSE_SENSEX"); setGroupIndexNSE("NIFTY") }}>
                                                <option value="BSE" selected>BSE</option>
                                                <option value="NSE">NSE</option>
                                            </select>
                                        </div>

                                        <div className='value-inner-selectIndex'>
                                            {(groupValue === "BSE") ?
                                                <select aria-label="bse sensex" onChange={(event) => { setGroupIndex(event.target.value) }}>
                                                    {dataGroup && dataGroup.map(({ Group }) => (
                                                        <option value={Group} selected={Group === "BSE_SENSEX"}>{Group}</option>
                                                    )
                                                    )}
                                                </select> : <select onChange={(event) => { setGroupIndexNSE(event.target.value) }}>
                                                    {dataGroup && dataGroup.map(({ Group }) => (
                                                        <option value={Group} selected={Group === "NIFTY"}>{Group}</option>
                                                    )
                                                    )}
                                                </select>}
                                        {/* </div> */}
                                    </div>
                                </div>
                                {/* <hr className="hrFiveUpDown"></hr> */}
                                <div className='value-table table-responsive'>
                                    <table className='table'>
                                        <thead>
                                            <tr>
                                                <th className='text-left'>Company Name</th>
                                                <th className='text-right'>Day's Closing Price(&#8377;)</th>
                                                <th className='text-right'>Prev. Close(&#8377;)</th>
                                                <th className='text-right'>5 Days Ago(&#8377;)</th>
                                                <th className='text-right'>5 Days Return(%)</th>

                                            </tr>
                                        </thead>
                                        {(groupValue === "BSE") ? 
                                        <tbody>
                                            {currentTableData && currentTableData.map(
                                                ({ Lname, currprice, PrevPrice, fiveDayPrice, PerChange, CO_CODE }) => (
                                                    <tr>
                                                        <td className="text-left"><h6 onClick={routeChange} data-id={Lname + '-' + CO_CODE}>{Lname}</h6></td>
                                                        <td className="text-right">{currprice}</td>
                                                        <td className="text-right">{PrevPrice}</td>
                                                        <td className="text-right">{fiveDayPrice}</td>
                                                        <td className="text-right">{PerChange.toFixed(2)}</td>

                                                    </tr>
                                                ))}
                                        </tbody> : 
                                        <tbody>
                                        {currentTableData && currentTableData.map(
                                            ({ Lname, currprice, PrevPrice, FiveDayPrice, PerChange, Co_Code }) => (
                                                <tr>
                                                    <td className="text-left"><h6 onClick={routeChange} data-id={Lname + '-' + Co_Code}>{Lname}</h6></td>
                                                    <td className="text-right">{currprice}</td>
                                                    <td className="text-right">{PrevPrice}</td>
                                                    <td className="text-right">{FiveDayPrice}</td>
                                                    <td className="text-right">{PerChange.toFixed(2)}</td>

                                                </tr>
                                            ))}
                                    </tbody> }
                                    </table>
                                    {loadingshow ? <div className="textcentervertex">
                                                        <Vortex
                                                            visible={true}
                                                            height="80"
                                                            width="80"
                                                            ariaLabel="vortex-loading"
                                                            wrapperStyle={{}}
                                                            wrapperClass="vortex-wrapper"
                                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                        />
                                                        <div className="model_popup">Please Wait...</div>
                                                    </div> : ""
                                                    }
                                </div>
                                {(data != null && data != []) ?
                                    <Pagination
                                        className="pagination-bar_peer"
                                        currentPage={currentPage}
                                        totalCount={(data.length != null) ? data.length : 0}
                                        pageSize={PageSize}
                                        onPageChange={page => setCurrentPage(page)}
                                    /> : <p className="errorPeer"> No Data Found !!! </p>}
                            </div>
                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default DayUpandDown;